import { createContext } from 'react';
import { noop } from 'helpers/utility';
import {} from 'interfaces/redux';
export const externalPaymentsClickContext = createContext(noop);
